import React, { createContext, useContext } from 'react';

import type { BannerSpec } from '@invideoio/web-shared/components/WebinarBanner/banner-specs';

/**
 * Carries the CMS-driven announcement-bar slides from `_app` down to the banner
 * component, which is rendered deep inside page layouts. `null` means "nothing
 * from the CMS" and lets `WebinarBanner` use its own hardcoded slides.
 */
export const AnnouncementBannersContext = createContext<BannerSpec[] | null>(
  null,
);

type Props = {
  banners: BannerSpec[] | null;
};

export const AnnouncementBannersProvider = ({
  banners,
  children,
}: React.PropsWithChildren<Props>) => (
  <AnnouncementBannersContext.Provider value={banners ?? null}>
    {children}
  </AnnouncementBannersContext.Provider>
);

export function useAnnouncementBanners() {
  return useContext(AnnouncementBannersContext);
}
